import { backboneViewProperties } from "./../../../decorators/backbone-properties";
import { IRequestOptions } from "./../../../search/interfaces/request-options";
import { AppEvents } from "./../../../app-events";
import { Container } from "aurelia-dependency-injection";
import { GenericTabView } from "./generic-tab";
import * as d3 from "d3";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

export interface IPlotResult {
    Year: number;
    Percent: number;
}

const dom = {
    MORE_BUTTON: ".category-more-button",
    SHOW_DATA_TABLE: ".category-show-data-table",
    JURISDICTION_FILTER_MESSAGE: ".category-jurisdiction-message",
    RELATION_TEXT_FILTER: ".relation-text-filter",
    LEGISLATIONS : ".treatment-cell",
    NO_MATCH_FOUND: ".no-matches-found",
    CATEGORY_TREND: ".category-trend"
};

@backboneViewProperties({
    className: "graph-scrollable"
})
export class CategoryTrendingGraphView extends GenericTabView {

    private appEvents: Backbone.Events;
    private constructor(options?: any) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public onShow() {
        this.drawTrend();
    }

    private drawTrend() {
        let results;
        const data = [];
        let chart;
        let bars;
        const margin = 40;
        const height = 400;
        let x;
        let y;
        let xAxis;
        let yAxis;
        const width = 800;

        results = d3.map(this.model.Data.get("CategoryTrend"));
        results.forEach((key, val) => {
            if (val.Year !== 0 && val.Count !== 0 || data.length > 0) {
                const result: IPlotResult = {
                    Year: val.Year,
                    Percent: parseFloat(val.Percentage)
                };
                data.push(result);
            }
        });

        const barWidth = (width / data.length);
        const maxPercentage = d3.max(data, (d) => d.Percent);

        chart = d3.select(this.$(".category-trend")[0]).append("svg")
            .attr("class", "chart")
            .attr("width", width)
            .attr("height", height)
            .append("g");

        x = d3.scale.linear()
            .domain([data[0].Year, new Date().getFullYear() + 1])
            .range([40, width]);

        y = d3.scale.linear()
            .domain([0, 102])
            .rangeRound([0, height - margin]);

        // Bars
        bars = chart.append("g").attr("class", "bars");

        if (barWidth > 0) {
             bars.selectAll("rect")
            .data(data)
            .enter().append("rect")
            .attr("x", (d, i) => x(d.Year) - .5)
            .attr("y", (d) => (height - margin) - y(d.Percent) + .5)
            .attr("class", "graph-bar")
            .attr("width", barWidth - 1)
            .attr("height", (d) => y(d.Percent))
            .on("click", (d, i) => { this.graphSearch(d.Year); })
            .append("g");
        }

        // Axis
        xAxis = (d3 as any).svg.axis()
            .scale(x)
            .tickFormat((d) => d)
            .tickSize(6, 3, 1);

        yAxis = (d3 as any).svg.axis()
            .scale(d3.scale.linear().domain([0, 102]).rangeRound([height - margin, 0]))
            .tickSize(6, 3, 1)
            .orient("left");

        chart.append("g")
            .attr("class", "x-axis")
            .attr("transform", "translate(0, " + (height - margin) + ")")
            .call(xAxis)
            .selectAll("text")
            .attr("dx", "-1em")
            .attr("dy", ".5em")
            .attr("transform", "rotate(-60)");

        chart.append("text")
            .attr("transform", "translate(0, " + (height - margin) + ")")
            .attr("x", width / 2)
            .attr("y", margin - 10)
            .text("Year");

        chart.append("g")
            .attr("class", "y-axis")
            .attr("transform", "translate(40, 0)")
            .call(yAxis);

        chart.append("text")
            .attr("transform", "rotate(-90) translate(-140)")
            .attr("y", 3)
            .attr("dy", ".55em")
            .style("text-anchor", "end")
            .text("Percentage");

        _.defer(() => {
            if ($(window).width() < window.screen.availWidth) {
                this.$(dom.CATEGORY_TREND).addClass("rotate-graph");
            }
        });
    }

    private graphSearch(year: number) {
        (d3 as any).event.stopPropagation();
        const options: IRequestOptions = {
            page: 1,
            query: "Category[\"" + this.model.Data.Title + "\"] Year[" + year + "]",
            order: "Relevance",
            materialTypes: [],
            includedCategoryFilters: [],
            includedProductFilters: null
        };

        this.appEvents.trigger(AppEvents.ResetSearch);
        this.appEvents.trigger(AppEvents.SearchRequest, options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/category-trending-graph.ts